// External libraries
import gql from 'graphql-tag';

//Internal Modules
import {
  BUYER_FRAGMENT,
  FUNDING_OPTIONS_FRAGMENT,
  THREE_DOMAIN_SECURE_FRAGMENT,
  THREE_DS_2_CONTINGENCY_FRAGMENT,
} from '../fragments';

export const CREATE_ONBOARDING_PAYMENT_PLAN_MUTATION = gql`
  mutation CreateOnboardingPaymentPlanMutation(
    $currencyConversionType: CheckoutCurrencyConversionType
    $cvv: String
    $encryptedCardLoginAccountNumber: String
    $fundingInstrumentId: String!
    $shareAddressWithDonatee: Boolean
    $shippingAddress: AddressInput
    $supportedThreeDsExperiences: [ThreeDSPaymentExperience]
    $token: String!
    $userType: OnboardingExperienceType!
  ) {
    createOnboardingPaymentPlan(
      currencyConversionType: $currencyConversionType
      cvv: $cvv
      encryptedCardLoginAccountNumber: $encryptedCardLoginAccountNumber
      fundingInstrumentId: $fundingInstrumentId
      shareAddressWithDonatee: $shareAddressWithDonatee
      shippingAddress: $shippingAddress
      token: $token
      userType: $userType
    ) {
      ...buyer

      flags {
        is3DSecureRequired
      }

      ...fundingOptions

      paymentContingencies {
        ...threeDomainSecure
        ...threeDSContingencyData
      }
    }
  }
  ${BUYER_FRAGMENT}
  ${FUNDING_OPTIONS_FRAGMENT}
  ${THREE_DOMAIN_SECURE_FRAGMENT}
  ${THREE_DS_2_CONTINGENCY_FRAGMENT}
`;
